import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Clients from "../pages/Clients";
import Portfolio from "../pages/Portfolio";
import Services from "../pages/Services";
import WebsiteDevelopment from "../pages/services/WebsiteDevelopment";
import AppDevelopment from "../pages/services/AppDevelopment";
import DigitalMarketing from "../pages/services/DigitalMarketing";
import ITConsulting from "../pages/services/ITConsulting";
import StartupConsulting from "../pages/services/StartupConsulting";
import SoftwareDevelopment from "../pages/services/SoftwareDevelopment";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import WebsiteDevelopmentBlog from "../pages/blogs/WebsiteDevelopmentBlog";
import DigitalMarketingBlog from "../pages/blogs/DigitalMarketingBlog";
import ITConsultingBlog from "../pages/blogs/ITConsultingBlog";
import Blogs from "../pages/Blogs";
import CaseStudy from "../pages/CaseStudy";


const Router = () => {

    const [headerData, setHeaderData] = useState([]);

    return (
        <BrowserRouter>

            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/website-development" element={<WebsiteDevelopment />} />
                <Route path="/services/app-development" element={<AppDevelopment />} />
                <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
                <Route path="/services/it-consulting" element={<ITConsulting />} />
                <Route path="/services/startup-consulting" element={<StartupConsulting />} />
                <Route path="/services/software-development" element={<SoftwareDevelopment />} />
                <Route path="/blog/website-development" element={<WebsiteDevelopmentBlog />} />
                <Route path="/blog/digital-marketing" element={<DigitalMarketingBlog />} />
                <Route path="/blog/it-consulting" element={<ITConsultingBlog />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/case-study" element={<CaseStudy />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="*" element={<Home />} />

            </Routes>
            <Footer headerData={headerData} />
        </BrowserRouter >


    )
}
export default Router;